<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import languageresources from "@/models/languageresources";

export default {
  mixins: [apibtoast, apigeneric, languageresources],
  page: {
    title: "Dil Çevirileri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("languageresources.Title"),
      items: [
        {
          text: this.$t("languageresources.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("languageresources.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("languageresources.Title"),
          active: true,
        },
      ],

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilterResourcename: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "resources",
        Page: this.Page,
        Filter: "&Resourcename=" + this.FilterResourcename,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = this.TableData[0].totalcount;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input
                        type="text"
                        @input="
                          FilterResourcename.length >= 3 ||
                          FilterResourcename.length == 0
                            ? Get()
                            : ''
                        "
                        v-model="FilterResourcename"
                        class="form-control"
                        :placeholder="$t('languageresources.Page.Arama')"
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"></div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("languageresources.Table.Resourcename") }}</th>
                      <th>{{ $t("languageresources.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.Resourcename }}</td>
                      <td style="width: 100px; text-align: center">
                        <b-button-group>
                          <b-button
                            variant="success"
                            v-b-modal.languageresources
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddEdit
        :Id="DataUpdate"
        :AddEdit="AddEdit"
        @TableUpdate="Get()"
        v-if="DataUpdate"
      />
    </Layout>
  </Loader>
</template>
